import * as _ from 'lodash'
import * as errorCodes from '../enums/error-codes'
import fileUtil from '../utils/file-util'

const REQUEST_TERMINATED = 'terminated'
const REQUEST_TIMEOUT = 'Timeout'
const UNSUPPORTED_CONTENT = 'Error'

/**
 * resolves an error object
 * @param error - the upload error response
 * @param file - the file used in the upload attempt
 * @returns error object
 */
let resolveError = (error, file, errorOptions) => {
  let errorObj = null
  let errorMessageArr = _.words(error)
  if (_.includes(errorMessageArr, REQUEST_TERMINATED) || _.includes(errorMessageArr, REQUEST_TIMEOUT)) {
    errorObj = {
      heading: errorOptions.defaultMessage + ' ' + fileUtil.fileName(file),
      message: errorOptions.CP404.message,
      suggestion: errorOptions.CP404.suggestion,
      code: errorCodes.CP_404
    }
    return errorObj
  } else if (_.includes(errorMessageArr, UNSUPPORTED_CONTENT)) {
    let errorObj = {
      heading: errorOptions.defaultMessage + ' ' + fileUtil.fileName(file),
      message: errorOptions.CP402.message,
      suggestion: errorOptions.CP402.suggestion,
      code: errorCodes.CP_402
    }
    return errorObj
  } else {
    switch (true) {
      case error.status >= 400 && error.status < 500:
        errorObj = {
          heading: errorOptions.defaultMessage + ' ' + fileUtil.fileName(file),
          message: errorOptions.CP404.message,
          suggestion: errorOptions.CP404.suggestion,
          code: errorCodes.CP_404
        }
        return errorObj
      case error.status < 600:
        errorObj = {
          heading: fileUtil.fileName(file),
          message: errorOptions.CP403.message,
          suggestion: errorOptions.CP403.suggestion,
          code: errorCodes.CP_403
        }
        return errorObj
      default:
        errorObj = {
          heading: fileUtil.fileName(file),
          message: errorOptions.CP403.message,
          suggestion: errorOptions.CP403.suggestion,
          code: errorCodes.CP_403
        }
        return errorObj
    }
  }
}
export default {
  resolveError
}
